module.exports = __webpack_public_path__ + "fonts/TTFirs-Thin.cddd6426.woff";